import React from "react";
import { useStudentsLists } from "../../../hooks/students/useStudentsLists.hooks";
import { useStudentListFilters } from "../../../hooks/filterHooks/useStudentFilterHooks";
import { StudentList } from "./StudentsList";

export const ActiveStudentList = () => {
  const { filters } = useStudentListFilters("ACTIVE_STUDENT");

  const { isLoading: isStudentsListLoading, data: studentsList } =
    useStudentsLists({
      page: filters?.page,
      filters: {
        ...(filters || {}),
      },
    });

  return (
    <StudentList
      isStudentsListLoading={isStudentsListLoading}
      studentsList={studentsList}
      studentListNameSpace="ACTIVE_STUDENT"
    />
  );
};
